import React from 'react';
import { WfCheckoutFramePreview } from '../components/frames/WfCheckoutFramePreview';
export function Checkout() {
  return <div className="mx-auto max-w-page px-5 py-14 md:px-10 md:py-20" data-id="element-453" data-mp="1ljlljhrazp75">
      <h1 className="font-display text-[46px] font-medium leading-tight text-ink md:text-[60px]" data-id="element-454" data-mp="1zkefo1dp0i9q">Checkout</h1>
      <div className="mt-12" data-id="element-455" data-mp="1um4k3po23fnl">
        <WfCheckoutFramePreview data-id="element-456" data-mp="1uluqzt7pssdo" />
      </div>
    </div>;
}